import {z} from 'zod';

const extractedImageSchema = z.object({
  name: z.string(),
  base64: z.string(),
  size: z.number().int(),
  mimeType: z.string(),
});

export const extractImagesFromZipResponseSchema = z.object({
  images: z.array(extractedImageSchema),
  totalFound: z.number().int(),
  totalReturned: z.number().int(),
  processingTimeMs: z.number(),
});

export type ExtractedImage = z.infer<typeof extractedImageSchema>;
export type ExtractImagesFromZipResponse = z.infer<typeof extractImagesFromZipResponseSchema>;
